import { states, territories } from '@scoir/states'
import { includes, isEmpty, orderBy, values, without } from 'lodash'

const statesList = orderBy([...states, ...territories], ['name'], ['asc'])

export const STATE_ABBREVIATIONS = [] // filled in immediately below

export const ALL_STATES = statesList.map((state) => {
  const value = state.value
  STATE_ABBREVIATIONS.push(value) // This is so it only has to loop through the states once
  return {
    value,
    label: state.name,
  }
})

export const OPTIONS = {
  all: {
    value: 'all',
    label: 'All States',
    getDefaultValue: () => [],
    getMatch: (value) => isEmpty(value),
  },
  in: {
    value: 'in',
    label: 'In State',
    getDefaultValue: (collegeState) => [collegeState],
    getMatch: (value, collegeState) => value.length === 1 && value[0] === collegeState,
  },
  out: {
    value: 'out',
    label: 'Out of State',
    getDefaultValue: (collegeState) => without(STATE_ABBREVIATIONS, collegeState),
    getMatch: (value, collegeState) => value.length === ALL_STATES.length - 1 && !includes(value, collegeState),
  },
  individual: {
    value: 'individual',
    label: 'Individually Selected States',
    getDefaultValue: () => [],
  },
}

export const getAppropriateOptionType = (value, collegeState) => {
  if (OPTIONS.all.getMatch(value)) {
    return OPTIONS.all.value
  }
  if (OPTIONS.in.getMatch(value, collegeState)) {
    return OPTIONS.in.value
  }
  if (OPTIONS.out.getMatch(value, collegeState)) {
    return OPTIONS.out.value
  }
  return OPTIONS.individual.value
}

export const DEFAULT_TYPE = OPTIONS.all.value

export const INDIVIDUAL_TYPE = OPTIONS.individual.value

export const OPTIONS_ARRAY = values(OPTIONS)

export const getOptions = (isInUnitedStates) => {
  if (!isInUnitedStates) {
    return without(OPTIONS_ARRAY, OPTIONS.in)
  }
  return OPTIONS_ARRAY
}
